const { trapFocus, disableTrapFocus } = window.BAO.Utils

class CollectionSort extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'panel']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.trigger.element,
      'click',
      this.onTriggerClick.bind(this),
    )
    this.listeners.add(this, 'focusin', this.onFocusIn.bind(this))
    this.listeners.add(this, 'keyup', this.onKeyUp.bind(this))
    this.listeners.add(document, 'click', this.onDocumentClick.bind(this))
  }

  /**
   * @param {MouseEvent} event
   *
   * @returns {void}
   */
  onTriggerClick (event) {
    event.stopPropagation()

    const isExpanded =
      this.els.panel.element.getAttribute('aria-expanded') === 'true'
    this.setExpanded(!isExpanded)
  }

  /**
   * @param {FocusEvent} event
   *
   * @returns {void}
   */
  onFocusIn (event) {
    if (!event.target.closest(this.localName)) {
      this.setExpanded(false)
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  onKeyUp (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return

    this.setExpanded(false)
    this.els.trigger.element.focus()
  }

  /**
   * @param {MouseEvent} event
   *
   * @returns {void}
   */
  onDocumentClick (event) {
    if (this.contains(event.target)) return
    if (this.els.panel.element.getAttribute('aria-expanded') !== 'true') return

    this.setExpanded(false)
  }

  /**
   * @param {Boolean} expanded
   *
   * @returns {void}
   */
  setExpanded (expanded) {
    this.els.trigger.element.setAttribute('aria-expanded', String(expanded))
    this.els.panel.element.setAttribute('aria-expanded', String(expanded))

    if (expanded) {
      trapFocus(this)
    } else {
      disableTrapFocus(this)
    }
  }
}

if (!customElements.get('collection-sort')) {
  customElements.define('collection-sort', CollectionSort)
}
